module.exports = __webpack_public_path__ + "static/img/gxg5.5a48f5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gxg5.png
// module id = hK/c
// module chunks = 2